import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';

import {
  signInActions,
  activeAccountCountrySel
} from 'src/store/modules/signin';

import SignIn from './SignIn';

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signInActions.signout())
});

const mapStateToProps = (state: any) => ({
  activeAccountCountry: activeAccountCountrySel(state)
});

export const pureComponent = SignIn;
export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(SignIn));

interface IDispatchFromProps {
  signout(): void;
}
